import '../styles/signinstyle.css'
import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Divider } from '@material-ui/core';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailAddress: "",
            title: "Forgot Password",
            isFetching: false,
        };

        localStorage.removeItem("authtoken");
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    componentDidMount() {
        //this.checkForLogin();
        //this.loginAction();
        //this.setState({
        //    passwordresetrandom: this.props.match.params.randomtoken
        //});
    }

    checkForLogin = () => {

        // setter
        //localStorage.setItem("authtoken", 555888);
        //// getter
        //localStorage.getItem('myData');
        //// remove
        //localStorage.removeItem('myData');
        //// remove all
        //localStorage.clear();
    }

    //handleInputChange = e => {
    //    let tmpformdatas = this.state.formdatas;
    //    tmpformdatas[e.target.name] = e.target.value;
    //    this.setState({
    //        formdatas: tmpformdatas
    //    });
    //};

    resetLink = async (event) => {

        await this.setState({ isFetching: true });

        event.preventDefault();

        await fetch(global.variables.API_USEROPERATIONS_FORGOTPASSWORD, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    window.location.href = "/login";
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });

        await this.setState({ isFetching: false });
    };

    render() {
        const { emailAddress, isFetching } = this.state
        return (
            <div className="romis-signin-bg">
                <Grid>
                    <ToastContainer />
                </Grid>
                <Grid container direction="row" justify="center" alignItems="center" >

                    <Card className="romis-img-card">
                        <div style={{ textAlign: "center", float: "left", paddingTop: 50 }}>
                            <img src="/images/financed.png" alt="" width="183px" height="93px" />
                            <Typography variant="caption" display="block" gutterBottom >
                                This project is co-financed by the European Union
                            </Typography>
                            <Typography variant="caption" display="block" gutterBottom >
                                and the Republic of Turkey.
                            </Typography>
                        </div>
                        <Divider orientation="vertical" />
                        <div style={{ textAlign: "center", float: "right" }}>

                            <img src="/images/rom_dark.png" alt="" width="384px" height="216px" />

                        </div>
                    </Card>

                </Grid>
                <Grid container direction="row" justify="center" alignItems="center" >

                    <Card style={{ maxHeight: 350 }}>
                        <CardHeader title="Forgot Password" className='romis-card-header' />
                        <CardContent>
                            <Typography variant="subtitle1" gutterBottom>Please enter your email address</Typography>
                            <Grid item>
                                <TextField
                                    label="Enter Your Email:"
                                    placeholder="Email"
                                    margin="normal" fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={emailAddress}
                                    onChange={this.handleChange.bind(this)}
                                    name="emailAddress"
                                    type="text"
                                />
                            </Grid>
                            <Grid item style={{ textAlign: "center" }}>
                                <Button variant="contained" color="primary"
                                    onClick={this.resetLink.bind(this)}
                                    disabled={isFetching ? true : false}> SEND </Button>
                            </Grid>
                            <Grid item>
                                <p>Click SEND to reset your password</p>
                            </Grid>
                        </CardContent>
                    </Card>

                </Grid>
                <Grid>
                    <div align="center">
                        <img src="/images/cfcu.png" alt="" width="62px" height="66px" />
                        <img src="/images/eptisa.png" alt="" width="105px" height="80px" style={{ marginLeft: 120, marginRight: 120 }} />
                        <img src="/images/europan.png" alt="" width="46px" height="46px" />
                    </div>
                </Grid>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./src/pages/ForgotPassword.js